import { useState } from "react";
import { LDSButton, LDSInputTextArea } from "@resmed/lumina-design-system";
import Icons from "@resmed/lumina-design-system-assets/dist/icons";

export interface MessageBoxProps {
  onSend?: (message: string) => void;
  onTyping?: (text: string) => void;
  /** True while the socket is reconnecting — disables send with a visible banner */
  reconnecting?: boolean;
}

const MessageBox = ({ onSend, onTyping, reconnecting = false }: MessageBoxProps) => {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    if (!message.trim() || reconnecting) return;
    onSend?.(message.trim());
    setMessage("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="lds-flex lds-flex-col lds-border lds-border-bordercolor-default lds-rounded-lg lds-overflow-hidden lds-bg-surface-raised-default">
      {reconnecting && (
        <div className="lds-flex lds-items-center lds-gap-2 lds-px-3 lds-py-2 lds-bg-bgcolor-weak lds-border-b lds-border-bordercolor-default">
          <div className="lds-w-2 lds-h-2 lds-rounded-full lds-bg-actions-warning lds-animate-pulse" />
          <span className="lds-text-xs lds-text-textcolor-caption">Reconnecting to chat…</span>
        </div>
      )}
      {/* Text input area */}
      <LDSInputTextArea
        id="message-input"
        placeholder="Type here..."
        rows={3}
        value={message}
        onChange={(e) => { setMessage(e.target.value); onTyping?.(e.target.value); }}
        onKeyDown={handleKeyDown}
        rootClassName="lds-h-16 lds-overflow-y-auto lds-border-none !lds-ring-0 hover:!lds-ring-0 focus:!lds-ring-0 lds-shadow-none lds-resize-none lds-rounded-none !lds-bg-surface-raised-default lds-w-full"
        containerClassName="lds-border-none lds-bg-surface-raised-default"
      />

      {/* Action bar */}
      <div className="lds-flex lds-items-center lds-justify-end lds-px-3 lds-py-2 lds-bg-surface-raised-default">
        <LDSButton
          id="send-btn"
          icon={Icons.FaArrowUp}
          severity="default"
          size="medium"
          disabled={reconnecting}
          onClick={handleSend}
        />
      </div>
    </div>
  );
};

export default MessageBox;
